export default {
  getAutocompleteVats: (state) => state.autocompleteVats,
  getVats: (state) => state.vats,
  getVat: (state) => (id) => {
    return state.vats.find(vat => vat.id === id)
  },
}